import { createTheme } from "@mui/material";
const defaultTheme = {
  variants: { solid: null },
  palette: {
    primary: {
      main: "#5E14A8",
    },
    text: {
      primary: "#5E14A8",
      pink: "#FF99D6",
    },
    sitePalette: {
      successClr: "#5AC491",
      warning: "#E8C342",
      error: "#E84242",
      secondaryColor: "#2A4C4B", //dark greenish
      secondaryColorLight: "#76D0D5", //light turquise
      grayClr: "#A9A9A9",
      linkHover: "rgb(246, 111, 192)",
      // Light Mode
      linerGradientBg:
        "linear-gradient(171.8deg, rgba(251, 60, 255, 0.5) -9.97%, rgba(50, 112, 205, 0.45) 45.69%, rgba(168, 66, 249, 0.5) 98.31%), #FFFFFF",
    },
    background: {
      darkContainer:
        "radial-gradient(100% 222.57% at 0% 15.3%, rgba(153, 94, 222, 0.42) 0%, rgba(114, 127, 247, 0.42) 55.21%, rgba(137, 78, 207, 0.42) 99.66%) , rgba(215, 186, 186, 0.12)",
      gradientBox:
        "linear-gradient(81.8deg, rgba(251, 60, 255, 0.5) -9.97%, rgba(50, 112, 205, 0.45) 45.69%, rgba(168, 66, 249, 0.5) 98.31%), #FFFFFF",
    },
  },
  typography: {
    fontFamily: ["ProximaNova", "Proxima Nova"].join(","),
  },
};

const baseTheme = createTheme(defaultTheme);

export const theme = createTheme(baseTheme, {
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "&:hover": {
            popupIndicator: {
              color: baseTheme.palette.primary.main,
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
          },
        },
        input: {
          padding: "8px 8px!important",
        },
        inputRoot: {
          borderRadius: "10px",
          padding: "4px 4px",
        },
        paper: {
          backgroundColor: "rgba(255, 255, 255, 0.01)",
          backdropFilter: "blur(15px)",
          borderRadius: "16px",
        },
        listbox: {
          backgroundColor: "transparent",
        },
        option: {
          backgroundColor: "transparent",
        },
        clearIndicator: {
          color: baseTheme.palette.primary.main,
        },
        popupIndicator: {
          color: "white",
          "&:hover": {
            color: baseTheme.palette.primary.main,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "10px!important",
          background:
            "radial-gradient(306.75% 102.31% at -35.18% 94.28%, rgba(240, 182, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: "10px!important",
          borderColor: "white",
          borderWidth: "1px",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white",
            padding: "0",
          },
          "& .MuiInputBase-inputAdornedEnd": {
            padding: "8px 0px 8px 8px",
          },
          "& .MuiInputBase-root": {
            padding: "0 0 0 8px",
          },
          "& .MuiButton-root": {
            borderRadius: "10px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          backgroundColor: "white",
          padding: "4px 8px",
          minWidth: "min-content",
          borderRadius: "6px",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255,255,255 0.12)",
          borderRadius: baseTheme.spacing(3),
          my: baseTheme.spacing(1),
          boxSizing: "border-box",
          background:
            "radial-gradient(100% 222.57% at 0% 15.3%, rgba(153, 94, 222, 0.55) 0%, rgba(114, 127, 247, 0.55) 55.21%, rgba(137, 78, 207, 0.55) 99.66%), rgba(255, 255, 255, 0.2)",
          padding: {
            xs: baseTheme.spacing(2),
            md: baseTheme.spacing(4),
          },
        },
      },
    },
  },
});
